
(function () {
  if (window.__livePriceTotal && window.__livePriceTotal.destroy) window.__livePriceTotal.destroy();

  var CONFIG = {
    SEPARATOR: ', ',            // "Add to cart, $7.50 USD"
    MULTIPLY_BY_QUANTITY: true, // true = unit price x quantity
    UPDATE_BUTTON: true,        // price inside the Add to cart button
    UPDATE_MAIN_PRICE: true     // big price at the top of the product info
  };

  var NUM_RE = /\d[\d.,]*/;
  var STYLE_ID = 'live-price-total-style';

  var observer = null, listeners = [], timers = {}, runTimes = [], pausedUntil = 0;

  function numFrom(text) {
    var m = (text || '').match(NUM_RE);
    if (!m) return null;
    var n = parseFloat(m[0].replace(/,/g, ''));
    return isNaN(n) ? null : n;
  }

  function formatNumber(n) {
    return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.price.live-total-on .price__regular,.price.live-total-on .price__sale{display:none!important}' +
      '.price .live-total-price{display:inline-block}';
    document.head.appendChild(s);
  }

  // Find variant data embedded in the page script by the theme
  function getVariantData(form) {
    var sectionId = (form.getAttribute('id') || '').replace(/^product-form-/, '');
    // Look for variant json script tag or fallback window variables
    var scriptTag = document.getElementById('ModelJson-' + sectionId) || 
                    document.querySelector('script[data-section="' + sectionId + '"]') ||
                    document.querySelector('#product-json-' + sectionId);
    
    // Alternatively look for global variant arrays injected in inline scripts nearby
    if (!window.__productVariantsMap) {
      window.__productVariantsMap = {};
      document.querySelectorAll('script').forEach(function(s) {
        var text = s.textContent;
        if (text && text.indexOf('var variants = [') !== -1 || text.indexOf('"variants":') !== -1) {
          try {
            var match = text.match(/var variants\s*=\s*(\[[\s\S]*?\]);/);
            if (match && match[1]) {
              window.__productVariantsMap[sectionId] = JSON.parse(match[1]);
            }
          } catch(e) {}
        }
      });
    }
    
    var variants = window.__productVariantsMap[sectionId];
    if (!variants) {
      // Try parsing from form inputs or select options
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        // Fallback: look at select options text
        var select = document.querySelector('select[name="id"]');
        if (select && select.selectedOptions && select.selectedOptions[0]) {
          var optText = select.selectedOptions[0].textContent;
          var val = numFrom(optText);
          if (val !== null) return { price: Math.round(val * 100) };
        }
      }
      return null;
    }

    // Find currently selected variant ID
    var idInput = form.querySelector('input[name="id"]');
    var selectedId = idInput ? idInput.value : null;
    
    if (selectedId) {
      var found = variants.find(function(v) { return String(v.id) === String(selectedId); });
      if (found) return found;
    }
    return variants[0] || null;
  }

  // Get unit price in cents
  function getUnit(form, sectionId) {
    // 1. Check Appstle widget first (if subscription is active)
    var widget = form.querySelector('.appstle_sub_widget');
    if (widget) {
      var option = null;
      var radios = widget.querySelectorAll('input[name="selling_plan"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) { option = radios[i].closest('.appstle_subscription_wrapper_option'); break; }
      }
      if (!option) option = widget.querySelector('.appstle_selected_background, .appstle-active-option');
      
      if (option) {
        var el = option.querySelector('.appstle_subscription_amount');
        if (el) {
          var text = el.textContent.trim();
          var value = numFrom(text);
          if (value != null) {
            return { value: value, text: text, isCents: false };
          }
        }
      }
    }

    // 2. Fallback to standard theme variant price data (in cents)
    var variant = getVariantData(form);
    if (variant && typeof variant.price === 'number') {
      var dollars = variant.price / 100;
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      // Format nicely matching theme convention
      var text = '$' + formatNumber(dollars) + ' ' + currency;
      return { value: dollars, text: text, isCents: true };
    }

    // 3. Final fallback: DOM scrape of regular/sale price text safely
    var box = document.getElementById('price-' + sectionId) || form.closest('.product');
    if (box) {
      var priceEl = box.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item');
      if (priceEl) {
        var text = priceEl.textContent.trim();
        var value = numFrom(text);
        if (value != null && value < 100000) { // Safety guard against weird large parses
          return { value: value, text: text, isCents: false };
        }
      }
    }

    return null;
  }

  function updateButton(btn, unit, total) {
    var span = btn.querySelector('span');
    if (!span) return;

    var current = span.textContent.trim();
    var suffix = span.getAttribute('data-price-suffix') || '';
    var base = (suffix && current.slice(-suffix.length) === suffix)
      ? current.slice(0, -suffix.length).trim()
      : current;
    if (!base) return;

    if (btn.disabled || !unit) {
      if (current !== base) span.textContent = base;
      span.removeAttribute('data-price-suffix');
      return;
    }

    var newSuffix = CONFIG.SEPARATOR + unit.text.replace(NUM_RE, formatNumber(total));
    var newText = base + newSuffix;
    if (span.textContent !== newText) span.textContent = newText;
    span.setAttribute('data-price-suffix', newSuffix);
  }

  function clearMainPrice(box) {
    if (!box) return;
    box.querySelectorAll('.live-total-price').forEach(function (el) { el.remove(); });
    box.querySelectorAll('.live-total-on').forEach(function (el) { el.classList.remove('live-total-on'); });
  }

  function updateMainPrice(sectionId, total, currencySymbol) {
    var box = document.getElementById('price-' + sectionId);
    if (!box) return;
    var price = box.querySelector('.price');
    var container = box.querySelector('.price__container');
    if (!price || !container) return;

    var src = container.querySelector('.price__regular .price-item--regular') ||
              container.querySelector('.price__sale .price-item--sale') ||
              container.querySelector('.price-item');
    var template = src ? src.textContent.trim() : '';
    if (numFrom(template) == null) { clearMainPrice(box); return; }

    var live = container.querySelector('.live-total-price');
    if (!live) {
      live = document.createElement('span');
      live.className = 'price-item price-item--last live-total-price';
      container.insertBefore(live, container.firstChild);
    }
    var text = template.replace(NUM_RE, formatNumber(total));
    if (live.textContent !== text) live.textContent = text;
    if (!price.classList.contains('live-total-on')) price.classList.add('live-total-on');
  }

  function getQty(form, sectionId) {
    if (!CONFIG.MULTIPLY_BY_QUANTITY) return 1;
    var qtyEl = form.querySelector('input[name="quantity"]') || document.getElementById('Quantity-' + sectionId);
    return qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
  }

  function updateForm(form) {
    var btn = form.querySelector('button.product-form__submit[name="add"]');
    if (!btn) return;

    var sectionId = (form.getAttribute('id') || '').replace(/^product-form-/, '');
    var unit = getUnit(form, sectionId);
    var qty = getQty(form, sectionId);
    var total = unit ? Math.round(unit.value * qty * 100) / 100 : null;

    if (CONFIG.UPDATE_BUTTON && unit) updateButton(btn, unit, total);

    if (CONFIG.UPDATE_MAIN_PRICE) {
      if (unit && qty > 1) {
        updateMainPrice(sectionId, total);
      } else {
        clearMainPrice(document.getElementById('price-' + sectionId));
      }
    }
  }

  function updateAll() {
    document.querySelectorAll('form[id^="product-form-"]').forEach(updateForm);
  }

  function run() {
    var now = Date.now();
    if (now < pausedUntil) return;
    runTimes = runTimes.filter(function (t) { return now - t < 1000; });
    if (runTimes.length > 40) { pausedUntil = now + 3000; return; }
    runTimes.push(now);
    updateAll();
  }

  function later(key, delay) {
    if (timers[key]) return;
    timers[key] = setTimeout(function () { timers[key] = null; run(); }, delay);
  }
  function schedule() {
    later('fast', 50);
    later('slow', 700);
  }

  function addListener(evt, fn) {
    document.addEventListener(evt, fn, true);
    listeners.push([evt, fn]);
  }

  function destroy() {
    if (observer) observer.disconnect();
    observer = null;
    listeners.forEach(function (l) { document.removeEventListener(l[0], l[1], true); });
    listeners = [];
    Object.keys(timers).forEach(function (k) { clearTimeout(timers[k]); });
    timers = {};
    document.querySelectorAll('.live-total-price').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.live-total-on').forEach(function (el) { el.classList.remove('live-total-on'); });
  }

  function debugInfo() {
    return Array.prototype.map.call(document.querySelectorAll('form[id^="product-form-"]'), function (form) {
      var sectionId = (form.getAttribute('id') || '').replace(/^product-form-/, '');
      var btn = form.querySelector('button.product-form__submit[name="add"]');
      var qtyEl = form.querySelector('input[name="quantity"]');
      var unit = getUnit(form, sectionId);
      return {
        formId: form.getAttribute('id'),
        hasAddButton: !!btn,
        unitPrice: unit ? unit.text : null,
        quantity: qtyEl ? qtyEl.value : null,
        buttonText: btn ? btn.textContent.trim() : null
      };
    });
  }

  window.livePriceDebug = function () {
    var info = debugInfo();
    if (console.table) console.table(info);
    return info;
  };

  function init() {
    ensureStyle();
    run();

    observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

    ['change', 'input', 'click'].forEach(function (evt) {
      addListener(evt, function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('quantity-input, .quantity, variant-radios, variant-selects, .appstle_sub_widget')) schedule();
      });
    });

    window.addEventListener('load', run);
  }

  window.__livePriceTotal = { run: run, destroy: destroy };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();